import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import SubmitButton from "../components/Buttons/submitButton";
import SecondaryButton from "../components/Buttons/secondaryButton";
import VaulDrawer from "../components/Modal/vaulModal";
;
const AsyncModal = ({ onConfirm, onDismiss, children, submitText, dismissText, ...props }) => {
    return (_jsx(VaulDrawer, { onClose: onDismiss, ...props, children: _jsx(VaulDrawer.Snap, { id: "item-1", children: _jsxs("div", { className: "flex flex-col items-center gap-2 mt-2", children: [children, _jsxs("div", { className: "h-full w-full space-y-3", children: [_jsx(SubmitButton, { type: "button", onClick: onConfirm, children: submitText ?? 'Confirm' }), dismissText &&
                                _jsx(SecondaryButton, { className: "w-full h-full py-3 !text-base text-primary-text", size: "xl", onClick: onDismiss, children: dismissText })] })] }) }) }));
};
const AsyncModalContext = React.createContext(null);
const AsyncModalProvider = ({ children }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogConfig, setDialogConfig] = React.useState(undefined);
    const openDialog = ({ content, actionCallback, submitText, dismissText }) => {
        setDialogOpen(true);
        setDialogConfig({ content, actionCallback, submitText, dismissText });
    };
    const resetDialog = () => {
        setDialogOpen(false);
    };
    const onConfirm = () => {
        resetDialog();
        dialogConfig?.actionCallback(true);
    };
    const onDismiss = () => {
        resetDialog();
        dialogConfig?.actionCallback(false);
    };
    return (_jsxs(AsyncModalContext.Provider, { value: { openDialog }, children: [_jsx(AsyncModal, { show: dialogOpen, setShow: setDialogOpen, onConfirm: onConfirm, onDismiss: onDismiss, onAnimationEnd: (v) => !v && setDialogConfig(undefined), submitText: dialogConfig?.submitText, dismissText: dialogConfig?.dismissText, modalId: "asyncModal", children: dialogConfig?.content }), children] }));
};
const useAsyncModal = () => {
    const context = React.useContext(AsyncModalContext);
    if (context === undefined) {
        throw new Error('useAsyncModal must be used within a AsyncModalProvider');
    }
    const getConfirmation = ({ content, dismissText, submitText }) => new Promise((res) => {
        context.openDialog({ content, actionCallback: res, submitText, dismissText });
    });
    return { getConfirmation };
};
export { AsyncModalProvider, useAsyncModal };
